import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BadgeIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12 19.1184C8.06777 19.1184 4.8 15.8551 4.8 11.9592C4.8 8.06329 8.06777 4.8 12 4.8C15.9322 4.8 19.2 8.06329 19.2 11.9592C19.2 15.8551 15.9322 19.1184 12 19.1184ZM3 11.9592C3 16.8571 7.08163 20.9184 12 20.9184C16.9184 20.9184 21 16.8571 21 11.9592C21 7.06122 16.9184 3 12 3C7.08163 3 3 7.06122 3 11.9592ZM13.3477 10.0846L12.0001 5.93701L10.6525 10.0846H6.2915L9.81963 12.6479L8.472 16.7955L12.0001 14.2321L15.5282 16.7955L14.1806 12.6479L17.7087 10.0846H13.3477Z"
      />
    </SvgIcon>
  );
});
